module.exports = __webpack_public_path__ + "static/media/pdx-floor-6.ffb4dd5a.png";